import React , {useState , useEffect}  from "react";
import styled, { keyframes } from "styled-components";
import BusinessCardHeader from "./BusinessCardHeader";
import BusinessCardAbout from './BusinessCardAbout';
import ActionsListContainer from './ActionsListContainer';
import {FadeIn} from '../../../libs/components/FadeIn'
import {Button} from "../../../libs/components/Button";
import CardGallery from './CardGallery';
import Icon from 'react-icons-kit';
import icons from '../../Icons/icons';
import SharingOptions from './Share';
import SimpleModal from '../../../libs/components/SimpleModal';
import BusinessDetails from './businessDetails';
import {components as actionComponents} from '../../Action';
import BusinessCardFooterContainer from "./BusinessCardFooterContainer";
// import styles from '@brainhubeu/react-carousel/lib/style.css';

const ActionsContainer = actionComponents.ActionsListContainer;

const BusinessCardLayout = styled.div`
  position: relative;
  direction: ${(props) => props.direction ? props.direction : 'rtl'};
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${(props) => props.backgroundColor ? props.backgroundColor : 'white'};
  
  max-width: 1200px;
  margin: auto;
  min-height: 100%;
`;

const BusinessCardDetails = styled.div`
  //TODO: in css url() is relative to the css file location , you should turn this to 'absolute' url 
  //by using process.env.REACT_APP_BASE_URL
  background-image: ${(props) => props.backgroundImage ? `url('${getAbsoluteUrl(props.backgroundImage)}')` : 'none'};
  // background-size: cover;
  background-size: cover;
  padding-bottom: 50px;
`;

const getAbsoluteUrl = (link) => {
  // const absoluteUrl = `${process.env.REACT_APP_BASE_URL}/${link.replace(/\\/g, '/')}`;
  const absoluteUrl = `${link.replace(/\\/g, '/')}`;
  return absoluteUrl;
}

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

//TODO: add images prop
export default function BusinessCard({ cardConfig , cardUrl , closeModal}) {

  const cardSettings = cardConfig.settings;
  const cardImages= cardConfig.images;
  const clientInfo = cardConfig.clientInfo;
  const [shareModalOpen,setShareModalOpen] = useState(false);
  const actionsColor = cardSettings.actionsSettings.color;
  const galleryImages = cardImages.galleryImages?.map(img => img.images);
  console.log('backgroundimage')
  console.log(cardImages.backgroundImage)
  const backgroundImage = cardImages.backgroundImage && !isEmpty(cardImages.backgroundImage) ? (!cardImages.backgroundImage.isLocal ? cardImages.backgroundImage.getImages().lg : cardImages.backgroundImage.images.file) : null;
  console.log(backgroundImage)
  return (
    <BusinessCardLayout 
      id="BusinessCard" 
      direction={cardSettings.bodySettings.direction}
      backgroundColor={cardSettings.backgroundSettings.backgroundColor} 
    >
      <BusinessCardDetails id="cardImage"
      backgroundImage={backgroundImage}>
      
      <BusinessCardHeader 
        title={cardSettings.headerSettings.title} 
        subTitle={cardSettings.headerSettings.subTitle} 
        avatar={cardImages.avatar}
        headerImage={cardImages.headerImage}
        titleColor={cardSettings.headerSettings.titleColor}
        titleFontWeight={cardSettings.headerSettings.titleFontWeight}
        subtitleColor={cardSettings.headerSettings.subtitleColor}
        />
      <ActionsListContainer/>
      <FadeIn>
        <Button text={cardSettings.bodySettings.direction === 'rtl' ? 'הוסף אותי לאנשי הקשר' : 'Add Contact'} color={actionsColor} link={`vcard/${clientInfo.businessname}.vcf`} fontColor={cardSettings.actionsSettings.fontColor} isDownload={true}/> 
      </FadeIn>
        {
          clientInfo.about ?
          <BusinessCardAbout about={clientInfo.about} direction={cardSettings.bodySettings.direction} fontColor={cardSettings.bodySettings.fontColor}/>
          :
          null
        }
        {
          // clientInfo.openingHours &&? 
          true ?
          <BusinessDetails 
          servicesDescription={clientInfo.servicesDescription} 
          servicesTitle={cardSettings.detailsSettings.servicesTitle}
          openingHours={clientInfo.openingHours} 
          openingHoursTitle={cardSettings.detailsSettings.openingHoursTitle}
          direction={cardSettings.bodySettings.direction === 'rtl' ? 'right' : 'left'}
          color={actionsColor} />
          : 
          null
        }
        {/* <img style={{zIndex:-1,height:'100%',width:'100%',position:'relative',top:0,left:0}} src={backgroundImage}/> */}
        </BusinessCardDetails>
        {
          cardImages.galleryImages.length > 0 ?
          //TODO: set images prop from images
          <CardGallery images={galleryImages} title={cardSettings.headerSettings.title} /> 
          : null
        }
        <SharingOptions cardUrl={cardUrl} title={cardSettings.shareSettings.title}/>
        <SimpleModal show={cardConfig.isModalOpen} isCircle={true} onClose={() => closeModal()}>
          <div>
            <div style={{whiteSpace: "pre-wrap",marginTop:'20px'}}>{clientInfo.modalDescription}</div>
            <Button text={'להזמנה לחץ כאן'} 
            color={actionsColor} 
            link={`https://wa.me/972526831155/?text=היי , אני יוצר/ת קשר בנוגע לכרטיסיה`} 
            fontColor={cardSettings.actionsSettings.fontColor} 
            icon={<Icon icon={icons['whatsapp']} />}
            />
          </div>
        </SimpleModal>
        <BusinessCardFooterContainer/>
    </BusinessCardLayout>
  );
}
